import {
  action,
  atom,
  onUpdate,
  reatomAsync,
  withAbort,
} from "@reatom/framework";
import { ProductControllerSearchSortByEnum } from "definitions/product-storage";
import { API } from "src/api";
import { withDebounce } from "src/common/pipes";
import { productSelectionStore } from "src/store/atoms";

import { filterAtom, sortAtom } from "../atoms";

export const productsCountAtom = atom<number | null>(null, "productsCountAtom");

export const searchProductCountFetcher = reatomAsync(async (ctx) => {
  const filterData = ctx.get(filterAtom);
  const sortData = ctx.get(sortAtom);
  const selectedProductSample = ctx.get(
    productSelectionStore.currentSelectionAtom,
  );

  const response = await API.productStorageApi
    .productControllerSearchCount(
      {
        query: filterData.search || undefined,
        categories: filterData.categoryIds?.map(Number),
        brands: filterData.brandIds?.map(Number),
        priceMin: filterData.priceFrom,
        priceMax: filterData.priceTo,
        currency: filterData.currency ?? "RUB",
        genders: filterData.genders,
        sources: filterData.sources,
        includeCustom: filterData.includeCustom,
        sortBy: sortData?.type ?? ProductControllerSearchSortByEnum.Popularity,
        ...(filterData.viewAllSelected && {
          selectionId: selectedProductSample?.id,
        }),
        excludeSelectionIds: filterData.excludeSamples?.map(Number),
      },
      {
        signal: ctx.controller.signal,
      },
    )
    .then((res) => res.data);

  return response.count;
}, "searchProductCountFetcher").pipe(withAbort());

const fetchProductsCount = action(async (ctx) => {
  const count = await ctx.schedule(() => searchProductCountFetcher(ctx));
  if (count !== undefined) {
    productsCountAtom(ctx, count);
  }
}, "fetchProductsCount");

const debouncedFetchProductsCount = fetchProductsCount.pipe(withDebounce(400));

onUpdate(filterAtom, (ctx) => debouncedFetchProductsCount(ctx));
onUpdate(sortAtom, (ctx) => debouncedFetchProductsCount(ctx));

export const isProductsCountLoading = atom(
  (ctx) => ctx.spy(searchProductCountFetcher.pendingAtom) > 0,
  "isProductsCountLoading",
);

export const searchProductCountStore = {
  productsCountAtom,
  searchProductCountFetcher,
  fetchProductsCount,
  isProductsCountLoading,
};
